import {_, React, classNames, withStyles, StyledProps, autorun, reaction, observable, action} from '@api'
import {AnchorButton} from '@blueprintjs/core'
import {Card, CardContent, Typography, CardHeader, Divider} from '@material-ui/core'
import {useStores} from '@modules'
import {deployments, globalStores, ISiteDeployment} from '@stores'
import {authStore} from '@utils'
import {disposeOnUnmount, observer} from 'mobx-react'
import * as Yup from 'yup'
import {withFormik} from 'formik'
import * as css from './Login.css'
import {TextInput, PrimaryButton, CheckboxInput} from 'centric-ui-components'

const styles = {
  container: {
    width: '100%',
    maxWidth: 640,
    maxHeight: 465
  },
  header: {
    textAlign: 'center',
    //padding: '1em 0'
    height: 80
  },
  loginCheckbox: {
    marginTop: 40
  }
}

interface MyProps extends StyledProps {
  values?: any,
  touched?: any,
  errors?: any,
  dirty?: boolean
  isSubmitting?: boolean
  keepMeLoginCheckbox?: boolean
  handleChange?: (e) => void
  handleBlur?: (e) => void
  handleSubmit?: (e) => void
  error?: { graphQLErrors?: Array<{ message: string }> },
  // eslint-disable-next-line
  onSubmit?: (e) => void
  // eslint-disable-next-line
  onLoginSuccess?: (result, input) => void
  // eslint-disable-next-line
  onLoginFailure?: (e) => void
}

@(withStyles as any)(styles)
@(withFormik as any)({
  mapPropsToValues: () => ({username: '', password: ''}),
  validationSchema: Yup
    .object()
    .shape({
      username: Yup
        .string()
        .required('Username is required'),
      password: Yup
        .string()
        .required('Password is required')
    }),
  handleSubmit: (values, {setSubmitting, props}) => {
    const {onSubmit, onLoginSuccess} = props

    onSubmit({variables: values})
      .then((result) => {
        setSubmitting(false)
        onLoginSuccess(result.data.login, values)
      }, () => {
        setSubmitting(false)
      })
  },
  displayName: 'LoginForm'
})
@observer
export class Login extends React.Component<MyProps> {
  static defaultProps = {
    headerLabel: 'Welcome!',
    keepMeLoginCheckbox: false
  }

  componentWillUnmount() {
    this.unmounting = true
  }

  unmounting = false

  @disposeOnUnmount
  setDefaultLoginFromDeployment = autorun(() => {
    if (DEBUG) {
      const {selectedDeployment, devLoginInfo} = deployments
      if (selectedDeployment) {
        if (selectedDeployment.login || devLoginInfo) {
          setTimeout(() => {
            if (this.unmounting) return
            const login = devLoginInfo?.login ?? selectedDeployment.login,
              password = devLoginInfo?.password ?? selectedDeployment.password

            const {props: {values}} = this
            values.username = login
            password && (values.password = password)
            values.dirty = true
            this.forceEnabledSubmit = true
            this.forceUpdate() // To make formik rerender
          }, 50)
        }
      }
    }
  })

  @observable forceEnabledSubmit = false

  get stores() { return globalStores }
  render() {
    const {
        props: {className, classes, error, values, touched, errors, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, keepMeLoginCheckbox},
        forceEnabledSubmit, stores: {site: {loginTitle}, deployments: {deploymentConfig}}
      } = this,
      gqlError = error?.graphQLErrors && error?.graphQLErrors[0]?.message,
      userNameError: any = errors.username && touched.username ? <span id='username-error'>Username is Required</span> : <span id='username-error'>Username</span>,
      passwordError: any = errors.password && touched.password ? <span id='password-error'>Password is Required</span> : <span id='password-error'>Password</span>
    return (
      <div className={classNames(className, css.root)}>
        <Card raised className={classes.container}>
          <CardHeader title={loginTitle} className={classNames(classes.header, css.header)}>
          </CardHeader>
          <Divider/>
          <CardContent className={css.content}>
            <form onSubmit={handleSubmit} autoComplete="on" className={css.loginForm}>
              <TextInput
                id='username'
                name='username'
                autoComplete='on'
                label={userNameError}
                type='text'
                placeholder={`Username`}
                value={values.username}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                autoFocus
                error={errors.username && touched.username}
                className={css.formInput}
              />

              <TextInput
                id='password'
                name='password'
                label={passwordError}
                type='password'
                autoComplete='on'
                placeholder={`Password`}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                error={errors.password && touched.password}
                className={classNames(css.formInput, css.password)}
              />

              <PrimaryButton type='submit'
                             fullWidth
                             data-id='login-btn'
                             disabled={!forceEnabledSubmit && (!dirty || isSubmitting || !!errors.username || !!errors.password) && !authStore.isLoggingIn}
                             className={classNames(classes.formInput, css.loginButton)}>
                LOGIN
              </PrimaryButton>

              {keepMeLoginCheckbox ? <CheckboxInput className={classes.loginCheckbox} name='name' label='Keep me logged in' value=''/> : null}

              {error && <Typography variant='subtitle1' id='login-error' className={css.errorMsg}>
                {gqlError
                 ? DEBUG ? gqlError : 'Authentication Error - Service is Unavailable'
                 : `Invalid User Credentials`
                }
              </Typography>}

            </form>
          </CardContent>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/components/widget/Login.tsx